import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./router/appRouter";
import reportWebVitals from "./reportWebVitals";
import { StoreProvider } from "./storage/provider";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-phone-number-input/style.css";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./global.css";

const options = {
  position: positions.BOTTOM_LEFT,
  timeout: 4000,
  offset: "10px",
  transition: transitions.FADE,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AlertProvider template={AlertTemplate} {...options}>
      <StoreProvider loadingComponent={"loading..."}>
        <AppRouter />
      </StoreProvider>
    </AlertProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
